function isDayFirstLocale(locale) {
  const userLocale = locale || typeof navigator !== "undefined" && navigator.language || typeof Intl !== "undefined" && Intl.DateTimeFormat().resolvedOptions().locale || "en-US";
  const dayFirstLocales = [
    "en-GB",
    "en-AU",
    "en-NZ",
    "en-IE",
    "en-ZA",
    "en-IN",
    "en-SG",
    "en-HK",
    "en-MY",
    "en-PH",
    "fr",
    "fr-FR",
    "fr-BE",
    "fr-CA",
    "fr-CH",
    "de",
    "de-DE",
    "es",
    "es-ES",
    "it",
    "it-IT",
    "pt",
    "pt-PT",
    "ru",
    "ru-RU",
    "uk",
    "uk-UA",
    "nl",
    "nl-NL",
    "zh-HK",
    "zh-MO"
    // Add more as needed
  ];
  const normalized = userLocale.split("-")[0];
  return dayFirstLocales.includes(userLocale) || dayFirstLocales.includes(normalized);
}
export {
  isDayFirstLocale
};
